<app-header id="top" *ngIf="userData !== undefined" [userData]="userData" [translation]="myLanguage" [unreadCount]="unreadNews"></app-header>


<div *ngIf="floatingSurveys !== undefined">
    <div class="fab-wrapper">
        <div class="col-lg-12 mb-3" *ngFor="let survey of floatingSurveys">
            <div class="floating-survey text-center">
                <p class="post-title"><strong>Neue EFS Umfrage</strong>:</p>
                <p class="post-title">{{ survey.headline }}</p>
                <button class="btn btn-efs btn-xs btn-primary" (click)="openSurvey(survey)">Umfrage öffnen</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="userData !== undefined && myLanguage !== undefined" class="content pt-4" role="main">
    <div class="container">

        <div class="row pt-4" *ngIf="motds !== undefined">
            <div class="col-lg-12 mb-3" *ngFor="let motd of motds">
                <article class="mb-3" class="mb-3 motd motd-{{motd.color}}">
                    <a href="{{ motd.link }}" *ngIf="motd.link !== ''">
                        <h1 class="post-title motd">{{ motd.header }}</h1>
                        <p class="post-body" [innerHTML]="motd.content"></p>
                    </a>

                    <a class="nocursor" *ngIf="motd.link === ''">
                        <h1 class="post-title nocursor motd">{{ motd.header }}</h1>
                        <p class="post-body nocursor" [innerHTML]="motd.content"></p>
                    </a>
                </article>
            </div>
        </div>

        <div class="row pt-4" *ngIf="loadedSurveySubmissions !== undefined">
            <div class="col-lg-12 mb-3" *ngFor="let submission of loadedSurveySubmissions">
                <article class="mb-3" style="height: auto;">
                    <h1 class="post-title">Umfrage: {{ submission.survey?.headline }}</h1>
                    <p class="post-body" [innerHTML]="submission.survey?.description"></p>


                    <div *ngFor="let answer of submission.answers">

                        <div *ngIf="!answer.question?.isDependencyQuestion || (answer.question?.isDependencyQuestion && answer.question?.showDependencyQuestion)"
                            class="mt-4" [ngClass]="{'has-validation-error': answer.validationError}">

                            <p class="post-body"><strong>{{ answer.question?.question }}</strong> <strong
                                    *ngIf="answer.question?.required" class="text-danger ms-1 fs-7">*</strong></p>
                            <p class="text-muted">{{ answer.question?.helperText }}</p>

                            <div *ngIf="answer.question?.valueType === 'text'">
                                <input type="text" class="form-control"
                                    placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                    [(ngModel)]="answer.value">
                            </div>

                            <div *ngIf="answer.question?.valueType === 'number'">
                                <input type="number" class="form-control"
                                    placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                    [(ngModel)]="answer.value">
                            </div>

                            <div *ngIf="answer.question?.valueType === 'date'">
                                <input type="date" class="form-control"
                                    placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                    [(ngModel)]="answer.value">
                            </div>

                            <div *ngIf="answer.question?.valueType === 'email'">
                                <input type="email" class="form-control"
                                    placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                    [(ngModel)]="answer.value">
                            </div>

                            <div *ngIf="answer.question?.valueType === 'color'">
                                <input type="color" class="form-control"
                                    placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                    [(ngModel)]="answer.value" style="width: 60px; height: 30px;">
                            </div>

                            <div *ngIf="answer.question?.valueType === 'range'">
                                <input type="range" min="0" max="5" class="rating rating--nojs" value="0" step="1"
                                    placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                    [(ngModel)]="answer.value">
                            </div>

                            <div *ngIf="answer.question?.valueType === 'radio'">
                                <div class="form-check" *ngFor="let option of answer.question?.valueOptions">

                                    <label class="form-check-label"
                                        [for]="'selectBoxId' + answer.question?.uniqueId+option">{{ option }}</label>

                                    <input class="form-check-input"
                                        [name]="'selectBoxId' + answer.question?.uniqueId+option"
                                        [id]="'selectBoxId' + answer.question?.uniqueId+option" type="radio"
                                        [checked]="isChecked(option, answer.values)" [value]="option"
                                        (change)="updateCheck(option, answer, submission, 'radio')">
                                </div>
                            </div>

                            <div *ngIf="answer.question?.valueType === 'checkbox'">
                                <div class="form-check" *ngFor="let option of answer.question?.valueOptions">
                                    <input class="form-check-input"
                                        [name]="'selectBoxId' + answer.question?.uniqueId+option"
                                        [id]="'selectBoxId' + answer.question?.uniqueId+option" type="radio"
                                        [checked]="isChecked(option, answer.values)" [value]="option"
                                        (change)="updateCheck(option, answer, submission, 'radio')">
                                    <label class="form-check-label"
                                        [for]="'selectBoxId' + answer.question?.uniqueId+option">{{ option }}</label>
                                </div>
                            </div>

                            <div *ngIf="answer.question?.valueType === 'select'">

                                <div class="form-check" *ngFor="let option of answer.question?.valueOptions">
                                    <input class="form-check-input"
                                        [name]="'selectBoxId' + answer.question?.uniqueId+option"
                                        [id]="'selectBoxId' + answer.question?.uniqueId+option" type="checkbox"
                                        [checked]="isChecked(option, answer.values)"
                                        (change)="updateCheck(option, answer, submission, 'checkbox')">
                                    <label class="form-check-label"
                                        [for]="'selectBoxId' + answer.question?.uniqueId+option">{{ option }}</label>
                                </div>
                            </div>

                            <div *ngIf="answer.question?.valueType === 'textarea'">
                                <textarea class="form-control"
                                    placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                    [(ngModel)]="answer.value"></textarea>
                            </div>

                            <p class="text-danger mt-2 mb-0" *ngIf="answer.validationError">{{ answer.validationError }}
                            </p>
                        </div>
                    </div>

                    <button class="btn btn-efs btn-xs btn-primary mt-3" (click)="submitSurvey(submission)">Umfrage
                        abschicken</button>

                    <p class="text-danger mt-2 mb-0" *ngIf="submission.hasIssues">Bitte überprüfe deine Eingaben.</p>
                </article>
            </div>
        </div>

        <div class="row welcome-container">
            <div class="col-md-12">
                <img class="logo mx-auto d-block" alt="EFS-IT-World Logo" src="assets/EFSITworld.svg">
            </div>
        </div>

        <div class="row welcome-container">
            <div class="col-md-12">
                <div class="text-center">
                    <h2>{{ myLanguage.opener.replace('%name', userData.given_name) }}</h2>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="myFavoriteApps">
            <div class="col-lg-12">
                <div class="apps mt-4">
                    <div class="row display-flex" style="justify-content: center;">
                        <div class="col-lg-3 col-md-3 col-sm-6 col-6 mb-4" *ngFor="let appItem of myFavoriteApps;">
                            <article class="app-list">

                                <div class="controls">
                                    <div>
                                        <svg *ngIf="!fixedItems.includes(appItem._id)"
                                            (click)="removeFromFavorites(appItem)" xmlns="http://www.w3.org/2000/svg"
                                            class="icon icon-tabler icon-tabler-heart removeFavoriteIcon me-1"
                                            width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5"
                                            stroke="#00205c" fill="#00205c" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path
                                                d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" />
                                        </svg>

                                        <svg (click)="moveUpFavorite(appItem)" *ngIf="appItem.order !== 1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="icon icon-tabler icon-tabler-arrow-big-left moveFavoriteIcon me-1"
                                            width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5"
                                            stroke="#00205c" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path
                                                d="M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z" />
                                        </svg>

                                        <svg (click)="moveDownFavorite(appItem)"
                                            *ngIf="appItem.order !== myFavoriteApps.length"
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="icon icon-tabler icon-tabler-arrow-big-right moveFavoriteIcon"
                                            width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5"
                                            stroke="#00205c" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path
                                                d="M4 9h8v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z" />
                                        </svg>
                                    </div>
                                </div>

                                <a target="_blank" href="{{ appItem.link }}"
                                    class="umami--click--launch-app-{{appItem.name.split(' ').join('')}}">
                                    <img data-bs-toggle="tooltip" data-bs-placement="top" [title]="appItem.name"
                                        class="logo mx-auto d-block" [alt]="appItem.name" [src]="appItem.logo">
                                    <p class="text-center mt-4 bold"
                                        [innerHTML]="appItem.description.replace('{email}', userData.email)"></p>

                                </a>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="myNonFavoriteApps">
            <div class="col-lg-12">

                <!-- accordion -->

                <div>
                    <span class="moreapps-show">{{ myLanguage.more_apps }}</span>
                    <div class="apps mt-4">
                        <div class="row display-flex" style="justify-content: center;">
                            <div class="col-2 col-md-2 col-sm-2 col-lg-1 col-xl-1 mb-4"
                                *ngFor="let appItem of myNonFavoriteApps;">

                                <ng-template #tipContent>
                                    <div class="p-2"
                                        [innerHtml]="appItem.description.replace('{email}', userData.email)">
                                    </div>
                                </ng-template>

                                <article class="app-list app-list-small">

                                    <div class="controls">
                                        <div>
                                            <svg (click)="addToFavorites(appItem)" xmlns="http://www.w3.org/2000/svg"
                                                class="icon icon-tabler icon-tabler-heart addFavoriteIcon" width="25"
                                                height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#00205c"
                                                fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path
                                                    d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" />
                                            </svg>
                                        </div>
                                    </div>

                                    <a class="appIcon" target="_blank" href="{{ appItem.link }}"
                                        class="umami--click--launch-app-{{appItem.name.split(' ').join('')}}">
                                        <img data-bs-toggle="tooltip" data-bs-placement="top" [title]="appItem.name"
                                            class="image-fluid mx-auto d-block" [alt]="appItem.name"
                                            [src]="appItem.logo">
                                    </a>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12" id="news">
                <div class="posts">

                    <div class="text-center mb-4">
                        <h2>{{ myLanguage.news }} <span *ngIf="unreadNews > 0" class="badge bg-efs news-badge">{{
                                unreadNews }} {{ myLanguage.unread_news }}</span></h2>
                    </div>

                    <div class="mb-3">
                        <input type="text" class="form-control news-search w-100" placeholder="Suche"
                            [(ngModel)]="search" (ngModelChange)="this.searchUpdate.next($event)">
                    </div>

                    <article class="mb-3 umami--click--news-readmore" *ngFor="let newsItem of pagedNews"
                        [routerLink]="['/news', newsItem._id]">

                        <div class="row">
                            <div class="col-lg-10 news-box">
                                <h1 class="post-title" style="margin: 0" *ngIf="!newsItem.read">
                                    <img src="assets/de-flag.svg"
                                        *ngIf="isInnendienstOrExtern && newsItem.countries.includes('de')" class="me-2"
                                        height="15" alt="">
                                    <img src="assets/at-flag.svg"
                                        *ngIf="isInnendienstOrExtern && newsItem.countries.includes('at')" class="me-2"
                                        height="15" alt="">
                                    <img src="assets/hu-flag.svg"
                                        *ngIf="isInnendienstOrExtern && newsItem.countries.includes('hu')" class="me-2"
                                        height="15" alt="">

                                    {{ newsItem.headline }}

                                    <small class="unread-badge">Ungelesen</small>
                                </h1>

                                <h1 class="post-title-read" style="margin: 0" *ngIf="newsItem.read">
                                    <img src="assets/de-flag.svg"
                                        *ngIf="isInnendienstOrExtern && newsItem.countries.includes('de')" class="me-2"
                                        height="15" alt="">
                                    <img src="assets/at-flag.svg"
                                        *ngIf="isInnendienstOrExtern && newsItem.countries.includes('at')" class="me-2"
                                        height="15" alt="">
                                    <img src="assets/hu-flag.svg"
                                        *ngIf="isInnendienstOrExtern && newsItem.countries.includes('hu')" class="me-2"
                                        height="15" alt="">

                                    {{ newsItem.headline }}
                                </h1>
                            </div>

                            <div class="col-lg-2 ">
                                <aside class="post-footer">
                                    <span class="time"><span class="ago">{{myLanguage.updated}} {{ (newsItem.updated
                                            |
                                            amFromUnix) |
                                            amLocale:
                                            browserLocale
                                            | amTimeAgo }}</span><span class="date">{{ (newsItem.updated |
                                            amFromUnix)
                                            |
                                            amLocale:
                                            browserLocale | amDateFormat:'LL' }}</span></span>

                                </aside>
                            </div>
                        </div>
                    </article>

                    <button class="btn btn-efs btn-xs btn-primary me-2 page-btn" (click)="prevPage()"
                        [disabled]="currentPage === 1">Zurück</button>

                    <span style="vertical-align: middle;">
                        Seite {{ currentPage }} von {{ maxPage() }}
                    </span>

                    <button class="btn btn-efs btn-xs btn-primary ms-2 page-btn" (click)="nextPage()"
                        [disabled]="currentPage === maxPage()">Weiter</button>
                </div>
            </div>


            <div class="col-lg-12">
                <div class="faqs">

                    <div class="text-center mb-4">
                        <h2>{{ myLanguage.faq }}</h2>
                        <p>{{ myLanguage.faq_header }}</p>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="apps mt-4">
                                <div class="row display-flex">
                                    <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4" *ngFor="let appItem of myApps;">
                                        <a *ngIf="selectedApp === appItem" class="faqapp faqapp-active"
                                            (click)="selectApp(appItem)">{{ appItem.name }}</a>
                                        <a *ngIf="selectedApp !== appItem" class="faqapp umami--click--faq-appselect"
                                            (click)="selectApp(appItem)">{{ appItem.name }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div *ngIf="selectedFaqs !== null">

                        <article class="mt-4 warning" *ngIf="selectedFaqs !== undefined && selectedFaqs.length === 0">
                            <h1 class="post-title warning" style="margin-top: 0;">{{ myLanguage.faq_no_questions }}
                            </h1>
                        </article>

                        <article class="mt-4" *ngFor="let selectedFaq of selectedFaqs;">
                            <h1 class="post-title umami--click--faq-open" style="margin-top: 0"
                                (click)="toggleFaq(selectedFaq)">{{ selectedFaq.question }}</h1>
                            <div *ngIf="openFaq === selectedFaq" class="post-body hidden mt-3"
                                [innerHTML]="safeHTML(selectedFaq.answer)"></div>
                        </article>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <script>

        (function () {
            document.getElementsByClassName('logo').tooltip();
        })();

    </script>

    <app-footer [translation]="myLanguage" [userData]="userData"></app-footer>